import ga4 from "@/lib/tracking/ga4Core";

const JOURNEY_DETAILS = "rent_now_pay_later_haraj";

export const sharedHarajRNPLTracker = ({ target, source, position }) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: JOURNEY_DETAILS,
    target,
    source,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
